import { render, staticRenderFns } from "./evidence-collection-form.vue?vue&type=template&id=2ee9196e&"
import script from "./evidence-collection-form.vue?vue&type=script&lang=js&"
export * from "./evidence-collection-form.vue?vue&type=script&lang=js&"
import style0 from "./evidence-collection-form.vue?vue&type=style&index=0&id=2ee9196e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports